import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import DashboardLayout from './layouts/DashboardLayout'
import MainLayout from 'src/layouts/MainLayout';
import MainLayout2 from './layouts/MainLayout2';
import LoginView from 'src/views/Auth/LoginView';
import UserVerificationView from 'src/views/Auth/UserVerificationView';
import NotFoundView from 'src/views/errors/NotFoundView';
import Movements from 'src/views/Movements';
import SalesView from 'src/views/Sales';
import ForgotPasswordView from 'src/views/Auth/ForgotPasswordView';
import ResetPasswordView from 'src/views/Auth/ResetPasswordView';
import EmailVerificationView from 'src/views/Auth/EmailVerificationView';
import TermsAndConditionPublicPage from 'src/views/Profile/TermsAndConditionsPublic';
import PrivacyPolicyPublicPage from 'src/views/Profile/PrivacyPolicyPublic';
import MainLayoutWithoutNavigation from 'src/layouts/MainLayoutWithoutNavigation';
import SetPasswordView from 'src/views/Auth/SetPasswordView';
import ExpiredPasswordView from './views/Auth/ExpiredPasswordView';


function Routing() {
  return (
    <Routes>
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<Movements />} />
        <Route path="/movements" element={<Movements />} />
        <Route path="/sales" element={<SalesView />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Route>

      <Route element={<MainLayout />}>
        {/* <Route path="sign-in" element={<LoginView />} />
        <Route path="forgot-password" element={<ForgotPasswordView />} />
        <Route path="reset-password" element={<ResetPasswordView />} />
        <Route path="set-password-user" element={<SetPasswordView />} />
        <Route path="email-verification" element={<EmailVerificationView />} />
        <Route path="password-expired" element={<ExpiredPasswordView />} /> */}
        <Route path="404" element={<NotFoundView />} />
      </Route>
      <Route element={<MainLayout2 />}>
        {/* <Route path="user-verification" element={<UserVerificationView />} /> */}
        <Route path="terms_and_conditions" element={<TermsAndConditionPublicPage />} />
        <Route path="privacy_policy" element={<PrivacyPolicyPublicPage />} />
      </Route>
      <Route element={<MainLayoutWithoutNavigation />}>
    </Route>
    </Routes>
  );
}

export default Routing;
